export default "__VITE_ASSET__U$BLUDI6__"